import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { DocumentLists } from "@portal/Components/Portal/PotalTabs/Documents/DocumentLists";
import { DocumentFilter } from "@portal/Components/Portal/PotalTabs/Documents/Filters/DocumentFilter";
import { Provider } from "jotai";

function DocumentListPage() {
  return (
    <>
      <Provider>
        <DocumentFilter />
        <DocumentLists />
      </Provider>
      <InvoiceDetailsView />
    </>
  );
}

export { DocumentListPage };
